export const SEARCH_PARAMS_INTERNAL = 'connection';
